import { AfterViewInit, Component, HostBinding, Input } from '@angular/core';
import { LayoutConfig } from './layout-config.class';
import { SidebarLink, SidebarLinkTypes } from './cbj-layout.models';
import { fade } from '../animations/index';
import { WindowService } from '../scroll/index';
export class CbjLayoutComponent implements AfterViewInit {
   classes = 'cbj-site-wrapper';
  config: LayoutConfig;
  sidebarOpen = false;
/**
 * @param {?} ws
 */
constructor(private ws: WindowService) {}
/**
 * @return {?}
 */
ngAfterViewInit() {
    for (const /** @type {?} */ link of this.config.sidebarLinks) {
      if (link.type === SidebarLinkTypes.DROPDOWN) {
        link.dropdownHeight = link.children.length * 47.33;
      }
    }
  }
/**
 * @return {?}
 */
get isMobile() {
    return this.ws.isMobile;
  }
/**
 * @return {?}
 */
linkClick() {
    if (this.config.closeOnClick) {
      this.toggleSidebar();
    }
  }
/**
 * @param {?} link
 * @return {?}
 */
toggleDropdown(link: SidebarLink) {
    link.dropdownShow = !link.dropdownShow;
  }
/**
 * @return {?}
 */
toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    this.toggleWrapperClass();
  }
/**
 * @return {?}
 */
toggleWrapperClass() {
    if (this.sidebarOpen) {
      this.config.toggleClasses.next({el: 'wrapper', classes: 'open', remove: false});
    }else {
      this.config.toggleClasses.next({el: 'wrapper', classes: 'open', remove: true});
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-layout',
  template: `
    <!-- Top Navbar -->
    <div class="row m-0">
        <nav class="navbar" [ngClass]="config.navbarClasses">
            <div class="navbar-brand">
                <ng-container *ngIf="config.useSidebar">
                    <i class="material-icons md-3 clickable"
                       (click)="toggleSidebar()"
                       cbjRipple
                    >menu</i>
                </ng-container>
                <ng-content select="[navbar-brand]"></ng-content>
            </div>

            <ng-content select="[navbar-content]"></ng-content>
        </nav>
    </div>

    <!-- Site Inner -->
    <div [class]="config.footerType === 2 ? 'cbj-site-inner-sticky' : 'cbj-site-inner'">

        <!-- Sidebar -->
        <ng-container *ngIf="config.useSidebar">
            <nav class="cbj-sidebar"
                 [ngClass]="{open: sidebarOpen}"
                 [cbjScrollbar]="config.sideScrollConfig">

                <ng-content select="[sidebar-header]"></ng-content>

                <!-- The sidebars links -->
                <div class="list-group">
                    <ng-container *ngFor="let link of config.sidebarLinks">
                        <ng-container [ngSwitch]="link.type">

                            <!-- Header Link -->
                            <div [class]="config.headingClass" *ngSwitchCase="0">
                                <div class="d-flex align-items-center">
                                    <i *ngIf="link.icon" class="material-icons">{{link.icon}}</i>
                                    <h4>{{link.text}}</h4>
                                </div>
                            </div>

                            <!-- Dropdown Link -->
                            <div *ngSwitchCase="1">
                                <div [class]="config.dropdownClass"
                                     [cbjRipple]="config.rippleConf"
                                     (click)="toggleDropdown(link)"
                                     [ngClass]="{show: link.dropdownShow}"
                                >
                                    <div class="d-flex align-items-center">
                                        <i *ngIf="link.icon" class="material-icons">{{link.icon}}</i>
                                        {{link.text}}
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <i class="material-icons rotate">keyboard_arrow_right</i>
                                    </div>
                                </div>
                                <div class="collapse" [ngStyle]="{'height.px': link.dropdownShow ? link.dropdownHeight : 0}">
                                    <ng-container *ngFor="let subLink of link.children">
                                        <a [class]="config.linkClass"
                                           [routerLink]="subLink.link"
                                           [routerLinkActive]="config.activeClass"
                                           [cbjRipple]="config.rippleConf"
                                           (click)="linkClick()"
                                        >
                                            {{subLink.text}}
                                        </a>
                                    </ng-container>
                                </div>
                            </div>

                            <!-- Regular Link -->
                            <div *ngSwitchCase="2">
                                <a [routerLink]="link.link"
                                   [routerLinkActive]="config.activeClass"
                                   [class]="config.linkClass"
                                   [cbjRipple]="config.rippleConf"
                                   (click)="linkClick()"
                                >
                                    <i *ngIf="link.icon" class="material-icons">{{link.icon}}</i>
                                    {{link.text}}
                                </a>
                                <div></div>
                            </div>

                        </ng-container>
                    </ng-container>
                </div>

                <ng-content select="[sidebar-footer]"></ng-content>

            </nav>
        </ng-container>

        <!-- Backdrop -->
        <div *ngIf="sidebarOpen"
             class="cbj-backdrop"
             (click)="toggleSidebar()"
             [@fade]>
        </div>

        <!-- Main Content -->
        <div class="cbj-main-content" [ngClass]="{open: sidebarOpen}" [cbjScrollbar]="config.mainScrollConfig">

            <ng-content select="[main-content]"></ng-content>

            <!-- Bottom Footer -->
            <ng-container *ngIf="config.footerType === 1">
                <nav class="navbar cbj-footer" [ngClass]="config.footerClasses">
                    <ng-content select="[cbj-footer]"></ng-content>
                </nav>
            </ng-container>
        </div>

    </div>

    <!-- Sticky Footer -->
    <ng-container *ngIf="config.footerType === 2">
        <nav class="navbar cbj-footer-sticky" >
            <ng-content select="[cbj-footer-sticky]"></ng-content>
        </nav>
    </ng-container>
  `,
  animations: [ fade(350, 'ease-in-out') ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: WindowService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'classes': [{ type: HostBinding, args: ['class', ] },],
'config': [{ type: Input, args: ['config', ] },],
};
}

function CbjLayoutComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjLayoutComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjLayoutComponent.ctorParameters;
/** @type {?} */
CbjLayoutComponent.propDecorators;
/** @type {?} */
CbjLayoutComponent.prototype.classes;
/** @type {?} */
CbjLayoutComponent.prototype.config;
/** @type {?} */
CbjLayoutComponent.prototype.sidebarOpen;
/** @type {?} */
CbjLayoutComponent.prototype.ws;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
